import {
    RaikoBaseDialogContentContainer, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoSectionContainer, RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {GamePeriodService} from "../../serverService/gameService/GamePeriodService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {GameService} from "../../serverService/gameService/GameService";

export default function AddNewGamePeriod({handleCloseDialog, handleAddNewGamePeriodToTable}) {


    const [gamePeriodName, setGamePeriodName] = useState("");
    const [registrationStartDate, setRegistrationStartDate] = useState("");
    const [registrationEndDate, setRegistrationEndDate] = useState("");
    const [competitionStartDate, setCompetitionStartDate] = useState("");
    const [competitionEndDate, setCompetitionEndDate] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    const service = new GamePeriodService();
    const gameService = new GameService()

    const [gameList, setGameList] = useState([]);
    const [selectedGameId, setSelectedGameId] = useState(-1)
    const [selectedGameTitle, setSelectedGameTitle] = useState("")
    const [selectedType, setSelectedType] = useState("REGISTRATION")

    useEffect(() => {
        if (typeof gameService !== 'undefined') {
            gameService.getGameList(0, 100)
                .then(response => {
                    setGameList([])
                    response.data.map((item, index) => {
                        setGameList(prev => [
                            ...prev,
                            raikoCustomSelectItemGenerator(item.id, item.title)
                        ])
                    })
                    if (response.data.length >0){
                        setSelectedGameId(response.data[0].id)
                        setSelectedGameTitle(response.data[0].title)
                    }
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {

            })
        }
    }, []);

    function handleAddNewGamePeriod() {
        setActionButtonLoading(true)
        service.addNewGamePeriod(
            gamePeriodName,
            selectedGameId,
            competitionStartDate,
            competitionEndDate,
            registrationStartDate,
            registrationEndDate,
            selectedType)
            .then(response => {
                handleCloseDialog()
                handleAddNewGamePeriodToTable(response)
                showSuccessMessage("دوره زمانی جدید با موفقیت افزوده شد.")
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن دوره زمانی"}
                hasActionButton
                actionButtonOnclickWithValidation={handleAddNewGamePeriod}
                actionButtonTitle={"افزودن"}
                actionButtonLoadingState={actionButtonLoading}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoGridOneColumn className={css`width: 100%`}>
                    <RaikoCustomSelect
                        labelText={"نام بازی"}
                        value={selectedGameId}
                        setValue={value => {
                            setSelectedGameId(value)
                            gameList.map((item) => {
                                if (parseInt(item.id) === parseInt(value))
                                    setSelectedGameTitle(item.title)

                            })
                        }}
                        items={gameList}
                    />
                    <RaikoCustomSelect
                        labelText={"نوع دوره زمانی"}
                        value={selectedType}
                        setValue={setSelectedType}
                        items={[
                            raikoCustomSelectItemGenerator("REGISTRATION", "ثبتنامی"),
                            raikoCustomSelectItemGenerator("OPERATION", "عملیاتی"),
                        ]}
                    />
                    <RaikoSimpleInputOutlined
                        labelText={"نام دوره زمانی"}
                        value={gamePeriodName}
                        setValue={setGamePeriodName}
                        required
                    />
                    <RaikoDatePicker
                        label={"تاریخ شروع ثبت نام"}
                        date={registrationStartDate}
                        setDate={setRegistrationStartDate}
                    />
                    <RaikoDatePicker
                        label={"تاریخ پایان ثبت نام"}
                        date={registrationEndDate}
                        setDate={setRegistrationEndDate}
                    />
                    <RaikoDatePicker
                        label={"تاریخ شروع دوره"}
                        date={competitionStartDate}
                        setDate={setCompetitionStartDate}
                    />
                    <RaikoDatePicker
                        label={"تاریخ پایان دوره"}
                        date={competitionEndDate}
                        setDate={setCompetitionEndDate}
                    />

                </RaikoGridOneColumn>

            </RaikoSectionContainer>

        </RaikoBaseDialogContentContainer>
    )
}